import React, { useState, useEffect } from 'react';

export default function VistaStock() {
  const [stock, setStock] = useState([]);
  const [cargando, setCargando] = useState(true);

  // Estados para la cascada de selección
  const [productoSel, setProductoSel] = useState('');
  const [formatoSel, setFormatoSel] = useState('');

  const cargarStock = async () => {
    try {
      const res = await fetch('https://api.pascolo.com.ar/api/admin/stock-consolidado');
      if (res.ok) {
        const data = await res.json();
        setStock(data);
      }
    } catch (error) {
      console.error("Error cargando el stock detallado:", error);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    cargarStock();
  }, []);

  // 1. Extraer lista de productos únicos disponibles en stock
  const productosUnicos = Array.from(
    new Set(stock.map(item => item.producto))
  ).sort();

  // 2. Filtrar formatos disponibles SOLO para el producto seleccionado
  const formatosDisponibles = Array.from(
    new Set(
      stock
        .filter(item => item.producto === productoSel)
        .map(item => item.formato)
    )
  ).sort();

  // 3. Filtrar los lotes finales basados en Producto + Formato seleccionado
  const lotesFinales = stock.filter(item => 
    item.producto === productoSel && item.formato === formatoSel
  );

  // Resetear el formato si el producto cambia
  const handleProductoChange = (e) => {
    setProductoSel(e.target.value);
    setFormatoSel(''); // Limpia el segundo selector
  };

  if (cargando) {
    return (
      <div style={{ padding: '30px', textAlign: 'center', fontFamily: 'sans-serif', color: '#666' }}>
        <h3>Cargando existencias de cámara...</h3>
      </div>
    );
  }

  return (
    <div style={{ padding: '30px', fontFamily: 'sans-serif', backgroundColor: '#fff', borderRadius: '8px' }}>
      
      {/* Encabezado */}
      <div style={{ marginBottom: '25px', borderBottom: '2px solid #000', paddingBottom: '15px' }}>
        <h2 style={{ margin: 0, color: '#000', fontWeight: '800', fontSize: '24px' }}>CONSULTA DE LOTES</h2>
        <p style={{ margin: '5px 0 0 0', color: '#666', fontSize: '14px' }}>Seleccioná un producto y su presentación para desglosar los lotes en cámara.</p>
      </div>

      {/* Selectores en Cascada */}
      <div style={{ display: 'flex', gap: '20px', marginBottom: '30px', backgroundColor: '#f8f9fa', padding: '20px', borderRadius: '8px', border: '1px solid #eee' }}>
        
        {/* Selector 1: Producto */}
        <div style={{ flex: 1 }}>
          <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '8px', fontSize: '14px', color: '#333' }}>
            1. Seleccionar Producto
          </label>
          <select 
            value={productoSel}
            onChange={handleProductoChange}
            style={{ width: '100%', padding: '12px', borderRadius: '6px', border: '1px solid #ccc', fontSize: '15px', backgroundColor: '#fff', cursor: 'pointer' }}
          >
            <option value="">-- Elegir Queso --</option>
            {productosUnicos.map(prod => (
              <option key={prod} value={prod}>{prod}</option>
            ))}
          </select>
        </div>

        {/* Selector 2: Formato (Se habilita solo si hay producto seleccionado) */}
        <div style={{ flex: 1 }}>
          <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '8px', fontSize: '14px', color: productoSel ? '#333' : '#999' }}>
            2. Seleccionar Formato
          </label>
          <select 
            value={formatoSel}
            onChange={(e) => setFormatoSel(e.target.value)}
            disabled={!productoSel}
            style={{ 
              width: '100%', 
              padding: '12px', 
              borderRadius: '6px', 
              border: '1px solid #ccc', 
              fontSize: '15px', 
              backgroundColor: productoSel ? '#fff' : '#e9ecef', 
              cursor: productoSel ? 'pointer' : 'not-allowed' 
            }}
          >
            <option value="">-- Elegir Formato --</option>
            {formatosDisponibles.map(formato => (
              <option key={formato} value={formato}>{formato}</option>
            ))}
          </select>
        </div>

      </div>

      {/* Panel de Resultados: Listado de Lotes */}
      <div>
        {!productoSel ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#888', fontStyle: 'italic', backgroundColor: '#fafafa', borderRadius: '6px', border: '1px solid #eee' }}>
            Esperando selección de producto...
          </div>
        ) : !formatoSel ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#888', fontStyle: 'italic', backgroundColor: '#fafafa', borderRadius: '6px', border: '1px solid #eee' }}>
            Por favor, seleccioná un formato para ver los lotes disponibles.
          </div>
        ) : lotesFinales.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#dc3545', fontWeight: 'bold' }}>
            No hay stock físico para esta combinación en este momento.
          </div>
        ) : (
          <div>
            <h3 style={{ fontSize: '16px', fontWeight: '700', marginBottom: '15px', color: '#333' }}>
              Lotes en Cámara para: <span style={{ color: '#009ee3' }}>{productoSel} ({formatoSel})</span>
            </h3>
            
            <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
              <thead>
                <tr style={{ backgroundColor: '#000', color: '#FFF' }}>
                  <th style={{ padding: '12px 15px', fontSize: '14px', fontWeight: '700', textAlign: 'center' }}>CÓDIGO DE LOTE</th>
                  <th style={{ padding: '12px 15px', fontSize: '14px', fontWeight: '700', textAlign: 'center' }}>FECHA ELABORACIÓN</th>
                  <th style={{ padding: '12px 15px', fontSize: '14px', fontWeight: '700', textAlign: 'center' }}>TIEMPO DE MADURACIÓN</th>
                  <th style={{ padding: '12px 15px', fontSize: '14px', fontWeight: '700', textAlign: 'right' }}>UNIDADES EN STOCK</th>
                </tr>
              </thead>
              <tbody>
                {lotesFinales.map((item, index) => {
                  // Formatear fecha de elaboración para que quede prolija (DD/MM/AAAA)
                  const fecha = item.fecha_elaboracion 
                    ? new Date(item.fecha_elaboracion).toLocaleDateString('es-AR', {
                        day: '2-digit', month: '2-digit', year: 'numeric'
                      })
                    : '-';

                  return (
                    <tr 
                      key={item.codigo_lote}
                      style={{ 
                        borderBottom: '1px solid #E0E0E0', 
                        backgroundColor: index % 2 === 0 ? '#FFFFFF' : '#F9F9F9' 
                      }}
                    >
                      <td style={{ padding: '15px', textAlign: 'center', fontFamily: 'monospace', fontWeight: 'bold', fontSize: '15px', color: '#333' }}>
                        {item.codigo_lote}
                      </td>
                      <td style={{ padding: '15px', textAlign: 'center', color: '#555' }}>
                        {fecha}
                      </td>
                      <td style={{ padding: '15px', textAlign: 'center' }}>
                        <span style={{ 
                          backgroundColor: item.dias_maduracion > 25 ? '#E8F5E9' : '#FFF3E0', 
                          color: item.dias_maduracion > 25 ? '#2E7D32' : '#E65100', 
                          padding: '5px 12px', 
                          borderRadius: '20px', 
                          fontSize: '13px', 
                          fontWeight: 'bold' 
                        }}>
                          {item.dias_maduracion} {item.dias_maduracion === 1 ? 'día' : 'días'}
                        </span>
                      </td>
                      <td style={{ padding: '15px', textAlign: 'right', fontWeight: '800', fontSize: '16px', color: '#000' }}>
                        {item.unidades_stock} u.
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

    </div>
  );
}